import PropTypes from "prop-types";
import styles from "./WrapContainer.module.css";

const WrapContainer = (props) => {
  return <div className={styles.wrapContainer}>{props.children}</div>;
};

WrapContainer.propTypes = {
  children: PropTypes.node,
};

export default WrapContainer;
